import "core-js/modules/es.function.name.js";
import _defineProperty from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["error", "name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { forwardRef } from 'react';
import { Input } from '@chakra-ui/react';

var InputBase = function InputBase(_ref, ref) {
  var error = _ref.error,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
    name: name,
    borderRadius: "4px",
    p: "8px 16px",
    w: "100%",
    h: "48px",
    color: "text.primary",
    boxSizing: "border-box",
    background: "gray.light",
    fontWeight: "400",
    fontSize: "1rem",
    borderColor: error ? 'red.400' : 'gray.border',
    border: "2px solid",
    _focus: {
      border: '2px solid gray.300'
    }
  }, rest), {}, {
    ref: ref
  }));
};

export var Inputext = /*#__PURE__*/forwardRef(InputBase);